import React from 'react';

//import Support from '../Support/Support';
import {LanguageButton, menuHomeOpen, UserButton} from './HeadersButtons';
import WishListButton from './HeadersButtons';
import { Link } from "react-router-dom";

import './header.css';
const common = require('../common/common');
const env = require("../../config.js").default;

class Header extends React.Component {

  componentDidMount(){
    const $ = window.$;
    $("html").attr("lang", common.get_localStorage("language"));

    $(window).on("scroll resize", (e) => {
      this.changeHeaderHeight();
    });
    $(document).ready(() => {this.changeHeaderHeight();});
  }

  changeHeaderHeight(){
    const $ = window.$;

    var deafultHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if($(window).width()<992 && $(window).scrollTop() > 50){
      $("#portal-top").height($(".header_centrato").height());
      $("#wishListContainer").css("top", $(".header_centrato").height());
      //$("#wishListContainer").css("height", "calc(100vh - " + $(".header_centrato").height() + "px )");
      $(".banner_center_header").hide();
    }else{
      $("#portal-top").height(deafultHeaderHeight);
      $("#wishListContainer").css("top", 'var(--header-height)');
      //$("#wishListContainer").css("height", "calc(100vh - var(--header-height))");
      $(".banner_center_header").show();
    }
    if($(window).scrollTop() > deafultHeaderHeight)
      $("#gotoTop").fadeIn("50");
    else
      $("#gotoTop").fadeOut("50");
  }

  render(props){
    return (
      <div>
        <div id="portal-top">
          <div className={this.props.headerType + " header_layer"} >
            <div className="" id="sw_service-navbar">
              <LeftHeaderElement activeElements={this.props.activeElements} openWishListFunction={this.props.openWishListFunction}></LeftHeaderElement>
              <CenterHeaderElement></CenterHeaderElement>
              <RightHeaderElement activeElements={this.props.activeElements} openWishListFunction={this.props.openWishListFunction}></RightHeaderElement>
            </div>
          </div>
        </div>
        <div id="portal-top-placeholder"></div>
        <div id="gotoTop" onClick={()=>{window.$("html, body").animate({ scrollTop:0 }, 500);}}><i className="fas fa-caret-up"></i></div>
      </div>
    )
  }
}


class LeftHeaderElement extends React.Component {
  render(props){
    return(
      <>
        <div className="topHeaderLeft" id="menu_fisso">
          <ul id="portal-personaltools-wrapper" className="nav nav-pills ">
            {
              (
                <>

                {this.props.activeElements.map((item, key) => {
                  var ret = "";
                  switch(item){
                    case "LanguageButton":
                      ret =  <LanguageButton key={key}></LanguageButton>;
                    break;
                    case "UserButton":
                      ret =  <UserButton key={key}></UserButton>;
                    break;
                    case "WishListButton":
                      ret =  <WishListButton key={key} openFunction={this.props.openWishListFunction}></WishListButton>;
                    break;
                    default:
                      ret = "";
                  }
                  return (ret);

                })}
                </>)
            }
          </ul>
        </div>

      </>
    )
  }
}

class CenterHeaderElement extends React.Component {
  render(){
    return(
      <div className="banner_center_header">
        <Link to="/" onClick={() => menuHomeOpen(false)}>
          <img src={env.STATIC + "custom/logo_" + env.CSOFT + ".png"} className="brand homepage_nav d-print-none" alt="Logo"/>
          <img src={env.STATIC + "custom/logo_stampa_" + env.CSOFT + ".png"} onError={(e)=>{e.target.onerror = null; e.target.src=env.STATIC + "custom/logo_" + env.CSOFT + ".png"}} className="brand homepage_nav d-none d-print-block" alt="Logo"/>
        </Link>
      </div>
    )
  }
}

class RightHeaderElement extends React.Component {
  render(){
    return(
      <div className="topHeaderRight">
        <ul id="portal-seach" className="nav nav-pills navbar-right">
          {
            (
              <>
              {this.props.activeElements.map((item, key) => {
                var ret = "";
                switch(item){
                  case "LanguageButton":
                    ret = <LanguageButton key={key}></LanguageButton>;
                  break;
                  case "UserButton":
                    ret =  <UserButton key={key}></UserButton>;
                  break;
                  case "WishListButton":
                    ret =  <WishListButton key={key} openFunction={this.props.openWishListFunction}></WishListButton>;
                  break;
                  default:
                    ret = "";
                }
                return ret;

              })}
              </>)
          }
        </ul>
      </div>
    )
  }
}


export default Header;
